
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from '@/layouts/simple';
import { GlobalEmptyComponent } from '@/components/common/GlobalComponent';

import styles from './index.module.scss';

const supportEmail = 'support@masgusto.com';
const webDesc = 'MásGusto';
export default function AccessibilityStatement() {
  return (
    <Layout title={'Accessibility Statement'}>
      <div className={styles.legalContent}>
        <h3>Weee! Inc. Accessibility Statement</h3>
        <p>
          {webDesc} is committed to delivering to all the communities we serve, and making sure our digital assets are
          accessible to all our customers.
        </p>
        <p>
          {webDesc} is committed to digital accessibility, and to conforming to the{' '}
          <a href="https://www.essentialaccessibility.com/blog/web-content-accessibility-guidelines-wcag/">
            Web Content Accessibility Guidelines (WCAG)
          </a>{' '}
          2.1, Level A and AA and complying with{' '}
          <a href="https://www.essentialaccessibility.com/blog/ada-guidelines-compliance/">
            Americans with Disabilities Act (ADA)
          </a>{' '}
          effective communication requirements, and other applicable regulations.
        </p>
        <p>
          To accomplish this, we have partnered with Level Access to administer our accessibility program and oversee
          its governance. Their accessibility program evaluates our digital products on an ongoing basis in accordance
          with best practices and is supported by a diverse team of accessibility professionals, including users of
          assistive technologies. The platform, moreover, goes beyond minimum compliance requirements by making an{' '}
          <a href="https://www.essentialaccessibility.com/sayweee?utm_source=weeehomepage&utm_medium=iconlarge&utm_term=eachannelpage&utm_content=header&utm_campaign=weee">
            assistive CX technology application
          </a>{' '}
          available to customers who have trouble typing, gesturing, moving a mouse, or reading. The application is free
          to download and it incorporates tools such as mouse and keyboard replacements, voice recognition, speech
          enablement, hands-free/touch-free navigation, and more.
        </p>
        <p>
          We want to hear from you if you encounter any accessibility barriers on our digital properties. Please contact
          our Customer Support at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
        </p>
      </div>
    </Layout>
  );
}

AccessibilityStatement.GlobalComponent = GlobalEmptyComponent;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/about/accessibility-statement',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  